import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { VERTICAL_ROUTE_MAP, getVerticalIdFromPath } from 'config/verticalRoutes'

const BASE_TITLE = 'IVIX'
const DEFAULT_PAGE_TITLE = 'Platform'
const HOME_PAGE_TITLE = 'Home'
const ENTITY_PAGE_SUFFIX = ' · Entity Overview'

const isHomePath = (pathname: string): boolean => pathname === '/' || pathname === '/dashboard'

const getPageTitle = (pathname: string): string => {
  if (isHomePath(pathname)) return HOME_PAGE_TITLE

  const verticalId = getVerticalIdFromPath(pathname)
  const verticalTitle = verticalId && VERTICAL_ROUTE_MAP[verticalId]?.title

  if (!verticalTitle) return DEFAULT_PAGE_TITLE

  const isEntityPage = pathname.startsWith('/vertical/')
  return isEntityPage ? `${verticalTitle}${ENTITY_PAGE_SUFFIX}` : verticalTitle
}

export const usePageTitle = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = `${getPageTitle(pathname)} | ${BASE_TITLE}`
  }, [pathname])
}
